export default {
    ValidateDiscountCode: 'api/private/discount',
    GetMasterAvailableTime : "api/private/courses/times",
    BookCourse : "api/private/courses/book",
    ProcessPayment : "api/private/courses/process_payment",

  };
  